import { createSelector } from '@reduxjs/toolkit';

import { userOrganizations } from './userOrganizations';
import { getOrganizationId } from '../organization/getOrganizationId';

export const writeAccess = createSelector(
  getOrganizationId,
  userOrganizations,
  function (organizationId, organizations) {
    if (organizationId !== null && organizationId !== 0) {
      const len = organizations.length;

      for (let i = 0; i < len; i++) {
        if (organizations[i].id === +organizationId) {
          return !organizations[i].readonly;
        }
      }

      console.error('Write access, no organization found for id ', organizationId, organizations);
    }
    return false;
  },
);
